import React from 'react'

import {BoxDesctiption} from '../ProductStyles'

function Description({text}) {
  return <BoxDesctiption>{text}</BoxDesctiption>
}

export default Description
